import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { TLabelType } from './index';

interface ILabelProps {
    textColor?: string,
    bgColor?: string,
    outlined?: boolean,
    type?: TLabelType,
}

export const Label = styled.div<ILabelProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    padding: 2px 8px;

    ${FONTS.LABEL};
    color: ${p => p.textColor || COLORS.LabelsText_2};
    white-space: nowrap;

    border: ${p => p.outlined ? `1.5px solid ${p.type ? p.textColor : p.bgColor}` : 'none'};
    background-color: ${p => p.outlined ? 'transparent' : p.bgColor || COLORS.LabelsBg_2};
    border-radius: ${BorderRadius.labelRadius};
`;

export const LabelContent = styled.span<{ type?: TLabelType }>`
    display: inline-flex;
    align-items: center;
    gap: 5px;

    ${({ type }) => type && `
        & > svg {
            #contour,
            #guts {
                stroke: ${COLORS[type]} !important;
            }
        }
    `}
`;
